<div class="col-sm-12" *ngIf="!isJourFerie && !isSuspension" id="pgmJourFerie" style="height: 100%; padding: 5px 0;">
    <div class="fiche col-sm-12" style="padding: 2px 20px 5px 20px;">
        <div class="text-right col-sm-12 pull-right" style="padding-right: 0;">
            <div class="col-sm-7 fiche-client">
                <div> Programmations </div>
            </div>
            <button class="uppercase" *ngIf ="!isHistoLoc" id="savecont" (click)="save()"> Enregistrer </button>
            <button class="uppercase btn-close" id="closeclt" (click)="fermer()"> Fermer </button>
        </div>
    </div>
    <div class="contente ligneBon  col-sm-12"  [ngClass]="{'disabledbutton':isHistoLoc}" *ngIf="societe.programBenneMultiperiodes"
        style="color: #000;padding: 15px; font-size: 13px;">
        <div class="col-sm-12 form-group p-0">
            <div class="col-sm-12 p-0">
                <div class="col-sm-5" style="padding: 0 5px;">
                    <button *ngIf ="!isHistoLoc"  class="btn-add" (click)="addLigne()">
                        <i class="fa fa-plus"></i>
                    </button>
                    <span  *ngIf ="!isHistoLoc"  (click)="addLigne()"> Ajouter période </span>
                </div>

                <h4 class="col-sm-7 text-right" style="padding: 0 5px;">
                    Liste des périodes
                </h4>
            </div>
        </div>
        <div class="col-sm-12" style="padding: 0 5px; " [ngStyle]="{'height': editPgm ? '110px' : 'calc(100% - 35px)'}">
            <ngx-datatable class="material" [rows]="listMouvementsParPeriode" style="height: 100%;"
                [columnMode]="'force'" [headerHeight]="30" [footerHeight]="0" [rowHeight]="'auto'"
                [selectionType]="'single'" [selected]="selected"
                [messages]="{emptyMessage: loadingIndicator ? 'Chargement ...' :'Pas de periode'}"
                [loadingIndicator]="loadingIndicator">

                <ngx-datatable-column prop="libellePeriode">
                    <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected"
                        let-selectFn="selectFn" let-sort="sortFn">
                        <div class="tableheader">
                            <span class="uppercase"> Période </span>
                        </div>
                    </ng-template>
                    <ng-template let-value="value" let-row="row" let-rowIndex="rowIndex" ngx-datatable-cell-template>
                        <div> {{ value || '' }} </div>
                    </ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column [width]="50" [cellClass]="'text-right'">
                    <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-row="row">
                        <button class="btn-detail"  [ngClass]="{'enabledbutton':isHistoLoc}" (click)="editLignePgm(row)">
                            <i class="fa fa-pencil"></i>
                        </button>
                        <button class="btn-detail" *ngIf="row.libellePeriode !== 'Par défaut'"
                            (click)="deleteLigne(row)">
                            <i class="fa fa-trash"></i>
                        </button>
                    </ng-template>
                </ngx-datatable-column>
            </ngx-datatable>
        </div>
        <div class="col-sm-12" *ngIf="editPgm" id="pgmJourFerie" style="height: calc(100% - 145px); padding: 5px 0;">
            <div class="fiche col-sm-12" style="padding: 5px 0;background-color: #fff;">
                <div class="text-right col-sm-12 pull-right" style="padding: 0; font-size: 22px;">
                    <div class="col-sm-7 fiche-client">
                        <div> Détail programme </div>
                    </div>
                    <button class="uppercase" *ngIf = "!isHistoLoc" id="savecont" (click)="closeEdit()" style="background-color: #e9e9e9;">
                        valider </button>
                    <button class="uppercase btn-close" [ngClass]="{'enabledbutton':isHistoLoc}" id="closeclt" (click)="editPgm = false;fermerEdit();"> Fermer </button>
                </div>
            </div>


            <div class="contente ligneBon col-sm-12"
                style="color: #000;padding: 15px; font-size: 13px;">
                <div class="col-sm-12">
                    <div class="form-group col-sm-12 calendrierPgm"
                        *ngIf="programmeEdit.libellePeriode !== 'Par défaut'">
                        <div class="col-sm-3" style="    padding: 13px 0;"> Date de début </div>
                        <app-input-date [class]="'col-sm-9 date'" [id]="'date11'"
                            [model]="programmeEdit.dateDebutPgmModel"
                            (changefct)="programmeEdit.dateDebut = $event; changeDate($event, 'dateDebut', programmeEdit, 'dateDebutPgmModel');"
                            [placeholder]="'Date fin'" [disable]="!programmeEdit.editDate"
                            (selectfct)="selectDate($event, '#date11')" [showDatepicker]="true"
                            [closeDatepickerOnSelect]="true">
                        </app-input-date>

                    </div>
                    <div class="form-group col-sm-12 calendrierPgm"
                        *ngIf="programmeEdit.libellePeriode !== 'Par défaut'">
                        <div class="col-sm-3" style="    padding: 13px 0;"> Date de fin </div>
                        <app-input-date [class]="'col-sm-9 date'" [id]="'date12'"
                            [model]="programmeEdit.dateFinPgmModel"
                            (changefct)="programmeEdit.dateFin = $event; programmeEdit.datePgm = $event; changeDate($event, 'dateFin', programmeEdit, 'dateFinPgmModel');"
                            [placeholder]="'Date fin'" [disable]="!programmeEdit.editDate"
                            (selectfct)="selectDate($event, '#date12')" [showDatepicker]="true"
                            [closeDatepickerOnSelect]="true">
                        </app-input-date>

                    </div>
                    <div class="form-group">
                        <app-autocomplete
                            (selectfunction)="programmeEdit.typeProgram = $event;programmeEdit.typeOperation = $event.id; programmeEdit.nbSemainesProgram = '1';"
                            [results]="listProgram" [highlight]="true" [isCombo]="true" [label]="'Opération'"
                            id="typeprogram" [placeholder]="'Opération'" [defaultselected]="programmeEdit.typeProgram"
                            [defaultsearch]="programmeEdit.typeProgram ? programmeEdit.typeProgram.libelleObjetEntite : ''">
                        </app-autocomplete>
                    </div>
                    <div class="form-group col-sm-12 calendrierPgm">
                        <div class="col-sm-11 pull-right" style="width: 385px;" *ngIf="programmeEdit.typeOperation === 1">
                            <div class="btn-group" role="toolbar">
                                <div class="btn btn-default" *ngFor="let jr of listJour"
                                    (click)="checkDayWeek(programmeEdit.listJoursMois, jr.id)"
                                    [ngClass]="{'btn-primary': selectedDay(programmeEdit.listJoursMois, jr.id), 'disabledbutton': jr.id < 0}"
                                    role="group">{{ jr.libelleObjetEntite }}
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-12 form-group"
                            *ngIf="!programmeEdit.typeOperation || programmeEdit.typeOperation === 0">
                            <mat-radio-group [(ngModel)]="programmeEdit.nbSemainesProgram">
                                <mat-radio-button [color]="'primary'" value="1">Tout type de semaine
                                </mat-radio-button>
                            </mat-radio-group>

                            <div class="btn-group col-sm-12" role="toolbar"
                                [ngClass]="{'disabledbutton': programmeEdit.nbSemainesProgram !== '1'}">
                                <div class="btn btn-default" role="group" *ngFor="let semaine of listSemaine"
                                    (click)="checkDayWeek(programmeEdit.listTtSemaine, semaine.id)"
                                    [ngClass]="{'btn-primary': selectedSemaine(programmeEdit.listTtSemaine, semaine.id), 'disabledbutton backgris': disableDay(semaine.id)}">
                                    {{ semaine.libelleObjetEntite }}</div>
                            </div>
                        </div>
                        <div class="col-sm-12"
                            *ngIf="!programmeEdit.typeOperation || programmeEdit.typeOperation === 0">
                            <mat-radio-group [(ngModel)]="programmeEdit.nbSemainesProgram"
                                (ngModelChange)="changeFrequence()">
                                <mat-radio-button [color]="'primary'" value="2"> Semaine paires-impaires
                                </mat-radio-button>
                            </mat-radio-group>

                            <div class="col-sm-12" style="padding: 0">
                                Semaine paire :
                                <div class="btn-group  col-sm-12" role="toolbar"
                                    [ngClass]="{'disabledbutton': programmeEdit.nbSemainesProgram !== '2'}">
                                    <div class="btn btn-default" role="group" *ngFor="let semaine of listSemaine"
                                        (click)="checkDayWeek(programmeEdit.listSemainePaire, semaine.id)"
                                        [ngClass]="{'btn-primary': selectedSemaine(programmeEdit.listSemainePaire, semaine.id), 'disabledbutton backgris': disableDay(semaine.id)}">
                                        {{ semaine.libelleObjetEntite }}</div>
                                </div>
                            </div>
                            <div class="col-sm-12" style="padding: 0">
                                Semaine impaire :
                                <div class="btn-group  col-sm-12" role="toolbar"
                                    [ngClass]="{'disabledbutton': programmeEdit.nbSemainesProgram !== '2'}">
                                    <div class="btn btn-default" role="group" *ngFor="let semaine of listSemaine"
                                        (click)="checkDayWeek(programmeEdit.listSemaineImpaire, semaine.id)"
                                        [ngClass]="{'btn-primary': selectedSemaine(programmeEdit.listSemaineImpaire, semaine.id), 'disabledbutton backgris': disableDay(semaine.id)}">
                                        {{ semaine.libelleObjetEntite }}</div>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-12" *ngIf="programmeEdit.typeOperation === 2">
                            <div class="btn-group" role="toolbar">
                                <div class="btn btn-default" role="group" *ngFor="let semaine of listSemaine"
                                    (click)="checkDayWeek(programmeEdit.listJoursMois1, semaine.id)"
                                    [ngClass]="{'btn-primary': selectedSemaine(programmeEdit.listJoursMois1, semaine.id), 'disabledbutton backgris': disableDay(semaine.id)}">
                                    {{ semaine.libelleObjetEntite }}</div>
                            </div>
                            <div class="btn-group" role="toolbar">
                                <div class="btn btn-default" role="group" *ngFor="let semaine of listSemaine"
                                    (click)="checkDayWeek(programmeEdit.listJoursMois2, semaine.id)"
                                    [ngClass]="{'btn-primary': selectedSemaine(programmeEdit.listJoursMois2, semaine.id), 'disabledbutton backgris': disableDay(semaine.id)}">
                                    {{ semaine.libelleObjetEntite }}</div>
                            </div>
                            <div class="btn-group" role="toolbar">
                                <div class="btn btn-default" role="group" *ngFor="let semaine of listSemaine"
                                    (click)="checkDayWeek(programmeEdit.listJoursMois3, semaine.id)"
                                    [ngClass]="{'btn-primary': selectedSemaine(programmeEdit.listJoursMois3, semaine.id), 'disabledbutton backgris': disableDay(semaine.id)}">
                                    {{ semaine.libelleObjetEntite }}</div>
                            </div>
                            <div class="btn-group" role="toolbar">
                                <div class="btn btn-default" role="group" *ngFor="let semaine of listSemaine"
                                    (click)="checkDayWeek(programmeEdit.listJoursMois4, semaine.id)"
                                    [ngClass]="{'btn-primary': selectedSemaine(programmeEdit.listJoursMois4, semaine.id), 'disabledbutton backgris': disableDay(semaine.id)}">
                                    {{ semaine.libelleObjetEntite }}</div>
                            </div>
                            <div class="btn-group" role="toolbar">
                                <div class="btn btn-default" role="group" *ngFor="let semaine of listSemaine"
                                    (click)="checkDayWeek(programmeEdit.listJoursMois5, semaine.id)"
                                    [ngClass]="{'btn-primary': selectedSemaine(programmeEdit.listJoursMois5, semaine.id), 'disabledbutton backgris': disableDay(semaine.id)}">
                                    {{ semaine.libelleObjetEntite }}</div>
                            </div>
                        </div>
                        <div class="col-sm-12" *ngIf="programmeEdit.typeOperation === 3">
                            Semaine
                            <div class="btn-group  col-sm-12" role="toolbar">
                                <div class="btn btn-default" role="group" *ngFor="let semaine of listSemaine"
                                    (click)="checkDayWeek(programmeEdit.listJoursDerSemaineMois, semaine.id)"
                                    [ngClass]="{'btn-primary': selectedSemaine(programmeEdit.listJoursDerSemaineMois, semaine.id), 'disabledbutton backgris': disableDay(semaine.id)}">
                                    {{ semaine.libelleObjetEntite }}</div>
                            </div>
                        </div>
                    </div>
                    <div class="form-group col-sm-12 calendrierPgm">
                        <div class="col-sm-4" style="    padding: 13px 0;"> Fréquence de </div>
                        <div class="input-group col-sm-8" style="border: 1px solid #B2ACACB3;">
                            <input type="text" class="form-control" aria-describedby="basic-addon2"
                                style="padding: 6px 12px;" [(ngModel)]="programmeEdit.frequence"
                                [readonly]="programmeEdit.nbSemainesProgram === '2'" style="box-shadow: none !important;
                                border: none !important;
                                opacity: 1;">
                            <span class="input-group-addon" id="basic-addon2" style="border: none !important;">
                                {{programmeEdit.typeOperation === 0 ? 'Semaine(s)' : 'Mois'}}
                            </span>
                        </div>

                    </div>
                    <div class="form-group col-sm-12 calendrierPgm">
                        <div class="col-sm-1" style="    padding: 13px 0;">
                            <input type="checkbox" id="checkbox-1-1 " class="regular-checkbox regular-checkbox-checked"
                                [(ngModel)]="programmeEdit.editDate" (change) = "setDefaultDateFin('programmeEdit')"
                                [disabled]="programmeEdit.libellePeriode !== 'Par défaut'">
                        </div>
                        <div class="col-sm-3" style="    padding: 13px 0;"> Date de fin </div>
                        <div *ngIf = 'programmeEdit.editDate'>
                          <app-input-date [class]="'col-sm-8 date'" [id]="'date1'" [model]="programmeEdit.datePgm"
                              (changefct)="programmeEdit.datePgm = $event; changeDatePgm($event);"
                              [placeholder]="'Date fin'"
                              [disable]="!programmeEdit.editDate || (programmeEdit.libellePeriode !== 'Par défaut' ? true : false)"
                              (selectfct)="selectDate($event, '#date1')" [showDatepicker]="true"
                              [closeDatepickerOnSelect]="true">
                          </app-input-date>
                        </div>

                    </div>
                    <div class="form-group col-sm-12 calendrierPgm">
                        <div class="col-sm-4 calendrierPgm"> Jours fériés : </div>
                        <div class="col-sm-8">
                            <label  [ngClass]="{'enabledbutton':isHistoLoc}" class=" text-left uppercase text-underline showfiche" (click)="showJourFerie()">
                                Définir
                            </label>
                        </div>
                    </div>
                    <div class="form-group col-sm-12 calendrierPgm">
                        <div class="col-sm-4 calendrierPgm"> Suspension : </div>
                        <div class="col-sm-8">
                            <label [ngClass]="{'enabledbutton':isHistoLoc}" class=" text-left uppercase text-underline showfiche" (click)="showSuspension()">
                                Définir
                            </label>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="contente ligneBon col-sm-10 col-sm-offset-1" [ngClass]="{'disabledbutton':isHistoLoc}" *ngIf="!societe.programBenneMultiperiodes"
        style="color: #000;padding: 15px; font-size: 13px;">

        <div class="col-sm-12">
            <div class="form-group">
                <app-autocomplete
                    (selectfunction)="mouvBenneProgramme.typeProgram = $event;mouvBenneProgramme.typeOperation = $event.id; mouvBenneProgramme.nbSemainesProgram = '1';"
                    [results]="listProgram" [highlight]="true" [isCombo]="true" [label]="'Opération'" id="typeprogram"
                    [placeholder]="'Opération'" [defaultselected]="mouvBenneProgramme.typeProgram"
                    [defaultsearch]="mouvBenneProgramme.typeProgram ? mouvBenneProgramme.typeProgram.libelleObjetEntite : ''">
                </app-autocomplete>
            </div>
            <div class="form-group col-sm-12 calendrierPgm">
                <div class="col-sm-11 pull-right" *ngIf="mouvBenneProgramme.typeOperation === 1">
                    <div class="btn-group" role="toolbar">
                        <div class="btn btn-default" *ngFor="let jr of listJour"
                            (click)="checkDayWeek(mouvBenneProgramme.listJoursMois, jr.id)"
                            [ngClass]="{'btn-primary': selectedDay(mouvBenneProgramme.listJoursMois, jr.id), 'disabledbutton': jr.id < 0}"
                            role="group">{{ jr.libelleObjetEntite }}
                        </div>
                    </div>
                </div>
                <div class="col-sm-12 form-group"
                    *ngIf="!mouvBenneProgramme.typeOperation || mouvBenneProgramme.typeOperation === 0">
                    <mat-radio-group [(ngModel)]="mouvBenneProgramme.nbSemainesProgram">
                        <mat-radio-button [color]="'primary'" value="1">Tout type de semaine
                        </mat-radio-button>
                    </mat-radio-group>

                    <div class="btn-group col-sm-12" role="toolbar"
                        [ngClass]="{'disabledbutton': mouvBenneProgramme.nbSemainesProgram !== '1'}">
                        <div class="btn btn-default" role="group" *ngFor="let semaine of listSemaine"
                            (click)="checkDayWeek(mouvBenneProgramme.listTtSemaine, semaine.id)"
                            [ngClass]="{'btn-primary': selectedSemaine(mouvBenneProgramme.listTtSemaine, semaine.id), 'disabledbutton backgris': disableDay(semaine.id)}">
                            {{ semaine.libelleObjetEntite }}</div>
                    </div>
                </div>
                <div class="col-sm-12"
                    *ngIf="!mouvBenneProgramme.typeOperation || mouvBenneProgramme.typeOperation === 0">
                    <mat-radio-group [(ngModel)]="mouvBenneProgramme.nbSemainesProgram"
                        (ngModelChange)="changeFrequence()">
                        <mat-radio-button [color]="'primary'" value="2"> Semaine paires-impaires
                        </mat-radio-button>
                    </mat-radio-group>

                    <div class="col-sm-12" style="padding: 0">
                        Semaine paire :
                        <div class="btn-group  col-sm-12" role="toolbar"
                            [ngClass]="{'disabledbutton': mouvBenneProgramme.nbSemainesProgram !== '2'}">
                            <div class="btn btn-default" role="group" *ngFor="let semaine of listSemaine"
                                (click)="checkDayWeek(mouvBenneProgramme.listSemainePaire, semaine.id)"
                                [ngClass]="{'btn-primary': selectedSemaine(mouvBenneProgramme.listSemainePaire, semaine.id), 'disabledbutton backgris': disableDay(semaine.id)}">
                                {{ semaine.libelleObjetEntite }}</div>
                        </div>
                    </div>
                    <div class="col-sm-12" style="padding: 0">
                        Semaine impaire :
                        <div class="btn-group  col-sm-12" role="toolbar"
                            [ngClass]="{'disabledbutton': mouvBenneProgramme.nbSemainesProgram !== '2'}">
                            <div class="btn btn-default" role="group" *ngFor="let semaine of listSemaine"
                                (click)="checkDayWeek(mouvBenneProgramme.listSemaineImpaire, semaine.id)"
                                [ngClass]="{'btn-primary': selectedSemaine(mouvBenneProgramme.listSemaineImpaire, semaine.id), 'disabledbutton backgris': disableDay(semaine.id)}">
                                {{ semaine.libelleObjetEntite }}</div>
                        </div>
                    </div>
                </div>
                <div class="col-sm-12" *ngIf="mouvBenneProgramme.typeOperation === 2">
                    <div class="btn-group" role="toolbar">
                        <div class="btn btn-default" role="group" *ngFor="let semaine of listSemaine"
                            (click)="checkDayWeek(mouvBenneProgramme.listJoursMois1, semaine.id)"
                            [ngClass]="{'btn-primary': selectedSemaine(mouvBenneProgramme.listJoursMois1, semaine.id), 'disabledbutton backgris': disableDay(semaine.id)}">
                            {{ semaine.libelleObjetEntite }}</div>
                    </div>
                    <div class="btn-group" role="toolbar">
                        <div class="btn btn-default" role="group" *ngFor="let semaine of listSemaine"
                            (click)="checkDayWeek(mouvBenneProgramme.listJoursMois2, semaine.id)"
                            [ngClass]="{'btn-primary': selectedSemaine(mouvBenneProgramme.listJoursMois2, semaine.id), 'disabledbutton backgris': disableDay(semaine.id)}">
                            {{ semaine.libelleObjetEntite }}</div>
                    </div>
                    <div class="btn-group" role="toolbar">
                        <div class="btn btn-default" role="group" *ngFor="let semaine of listSemaine"
                            (click)="checkDayWeek(mouvBenneProgramme.listJoursMois3, semaine.id)"
                            [ngClass]="{'btn-primary': selectedSemaine(mouvBenneProgramme.listJoursMois3, semaine.id), 'disabledbutton backgris': disableDay(semaine.id)}">
                            {{ semaine.libelleObjetEntite }}</div>
                    </div>
                    <div class="btn-group" role="toolbar">
                        <div class="btn btn-default" role="group" *ngFor="let semaine of listSemaine"
                            (click)="checkDayWeek(mouvBenneProgramme.listJoursMois4, semaine.id)"
                            [ngClass]="{'btn-primary': selectedSemaine(mouvBenneProgramme.listJoursMois4, semaine.id), 'disabledbutton backgris': disableDay(semaine.id)}">
                            {{ semaine.libelleObjetEntite }}</div>
                    </div>
                    <div class="btn-group" role="toolbar">
                        <div class="btn btn-default" role="group" *ngFor="let semaine of listSemaine"
                            (click)="checkDayWeek(mouvBenneProgramme.listJoursMois5, semaine.id)"
                            [ngClass]="{'btn-primary': selectedSemaine(mouvBenneProgramme.listJoursMois5, semaine.id), 'disabledbutton backgris': disableDay(semaine.id)}">
                            {{ semaine.libelleObjetEntite }}</div>
                    </div>
                </div>
                <div class="col-sm-12" *ngIf="mouvBenneProgramme.typeOperation === 3">
                    Semaine
                    <div class="btn-group  col-sm-12" role="toolbar">
                        <div class="btn btn-default" role="group" *ngFor="let semaine of listSemaine"
                            (click)="checkDayWeek(mouvBenneProgramme.listJoursDerSemaineMois, semaine.id)"
                            [ngClass]="{'btn-primary': selectedSemaine(mouvBenneProgramme.listJoursDerSemaineMois, semaine.id), 'disabledbutton backgris': disableDay(semaine.id)}">
                            {{ semaine.libelleObjetEntite }}</div>
                    </div>
                </div>
            </div>
            <div class="form-group col-sm-12 calendrierPgm">
                <div class="col-sm-4" style="    padding: 13px 0;"> Fréquence de </div>
                <div class="input-group col-sm-8" style="border: 1px solid #B2ACACB3;">
                    <input type="text" class="form-control" aria-describedby="basic-addon2" style="padding: 6px 12px;"
                        [(ngModel)]="mouvBenneProgramme.frequence"
                        [readonly]="mouvBenneProgramme.nbSemainesProgram === '2'" style="box-shadow: none !important;
                        border: none !important;
                        opacity: 1;">
                    <span class="input-group-addon" id="basic-addon2" style="border: none !important;">
                        {{mouvBenneProgramme.typeOperation === 0 ? 'Semaine(s)' : 'Mois'}}
                    </span>
                </div>

            </div>
            <div class="form-group col-sm-12 calendrierPgm">
                <div class="col-sm-1" style="    padding: 13px 0;">
                    <input type="checkbox" id="checkbox-1-1 " class="regular-checkbox regular-checkbox-checked"
                        [(ngModel)]="mouvBenneProgramme.editDate" (change) = "setDefaultDateFin('mouvBenneProgramme')">
                </div>
                <div class="col-sm-3" style="    padding: 13px 0;"> Date de fin </div>
                <!-- <input type="text" [disabled]="!mouvBenneProgramme.editDate" class="col-sm-8 date" id="date1"
                    [ngModel]="mouvBenneProgramme.datePgm"
                    (ngModelChange)="mouvBenneProgramme.datePgm = $event; changeDatePgm($event);"
                    placeholder="Date de fin" ngbDatepicker NgbInputDatepicker [autoClose]="false" #dPgm="ngbDatepicker"
                    (focus)="dPgm.open();" (dateSelect)="selectDate($event, '#date1')" (keydown.enter)="dPgm.close();"
                    autocomplete="off"> -->
                    <div *ngIf = "mouvBenneProgramme.editDate">
                      <app-input-date [class]="'col-sm-8 date'" [dateVide] = "true" [id]="'date1'" [model]="mouvBenneProgramme.datePgm"
                          (changefct)="mouvBenneProgramme.datePgm = $event; changeDatePgm($event);" [placeholder]="'Date fin'"
                          [disable]="!mouvBenneProgramme.editDate" (selectfct)="selectDate($event, '#date1')"
                          [showDatepicker]="true" [closeDatepickerOnSelect]="true">
                      </app-input-date>
                    </div>

            </div>
            <div class="form-group col-sm-12 calendrierPgm">
                <div class="col-sm-4 calendrierPgm"> Jours fériés : </div>
                <div class="col-sm-8">
                    <label [ngClass]="{'enabledbutton':isHistoLoc}" class=" text-left uppercase text-underline showfiche" (click)="showJourFerie()">
                        Définir
                    </label>
                </div>
            </div>
            <div class="form-group col-sm-12 calendrierPgm">
                <div class="col-sm-4 calendrierPgm"> Suspension : </div>
                <div class="col-sm-8">
                    <label [ngClass]="{'enabledbutton':isHistoLoc}" class=" text-left uppercase text-underline showfiche" (click)="showSuspension()">
                        Définir
                    </label>
                </div>
            </div>
        </div>
    </div>
</div>



<div class="ficheclt" *ngIf="isJourFerie" [ngStyle]="{'right': (modifier) ? '550px' : '550px'}">
    <app-pgm-jours-feries
        [tableConfigJoursFeries]="editPgm ? programmeEdit.tableConfigJoursFeries : mouvBenneProgramme.tableConfigJoursFeries"
        (hidefunction)="showJourFerie()" [isHistoLoc] = "isHistoLoc" (validefunction)="saveJourFerier($event)"></app-pgm-jours-feries>
</div>
<div class="ficheclt" *ngIf="isSuspension" [ngStyle]="{'right': (modifier) ? '550px' : '550px'}">
    <app-pgm-suspension [programme]="editPgm ? programmeEdit : mouvBenneProgramme"  [isHistoLoc] = "isHistoLoc"  (hidefunction)="showSuspension()"
        (validefunction)="saveSuspension($event)"></app-pgm-suspension>
</div>

<ng-template #msg>
    <div class="modal-body" style="height: auto">
        <div>
            <div class="col-sm-12">
                <strong class="cofirmemsg"> {{ error }} </strong>
            </div>
        </div>
        <div class="text-right" style="margin-top: 15px;">
            <button type="button" class=" btn-close btn-valider" (click)="common.closeModal()"> Fermer </button>
        </div>
    </div>
</ng-template>
